
import _surveyStore from '../Shared/UserProfile/Scripts/Survey/_surveyStore';
export default {
  _surveyStore: _surveyStore
};